import { DateCell } from './DateCell';

/*
 * Timeline (spec §7.3, §7.5). Renders append-only event/ledger/audit lists.
 * Domain-free: the feature maps its events into these items.
 */
export interface TimelineItem {
  id: string;
  title: string;
  at: string;
  detail?: string;
}

export function Timeline({ items }: { items: TimelineItem[] }) {
  return (
    <ol className="relative flex flex-col gap-4 border-l border-border pl-6">
      {items.map((item) => (
        <li key={item.id} className="relative">
          <span
            className="absolute top-1 -left-6 size-2.5 -translate-x-1/2 rounded-full bg-primary ring-4 ring-background"
            aria-hidden
          />
          <div className="flex flex-col gap-0.5">
            <p className="text-sm font-medium">{item.title}</p>
            {item.detail ? (
              <p className="text-sm text-muted-foreground">{item.detail}</p>
            ) : null}
            <span className="text-xs text-muted-foreground">
              <DateCell value={item.at} withTime />
            </span>
          </div>
        </li>
      ))}
    </ol>
  );
}
